const GENERIC_DESTINATION = Object.freeze({
  id: "default",
  name: "your destination",
  product: "Clikkle Auth",
  type: "platform",
  preparingLabel: "Preparing your destination…",
});

const DESTINATION_RULES = Object.freeze([
  { match: /continue\.clikkle\.com/i, value: { id: "continue", name: "Continue", product: "Clikkle Continue", type: "gateway", preparingLabel: "Preparing Continue…" } },
  { match: /(os\.app|os|n5)\.clikkle\.com/i, value: { id: "n5", name: "N5", product: "N5 Operating System", type: "operating-system", preparingLabel: "Preparing N5…" } },
  { match: /(app|worksuite)\.clikkle\.com/i, value: { id: "worksuite", name: "Worksuite", product: "Clikkle Worksuite", type: "business-platform", preparingLabel: "Preparing Worksuite…" } },
  { match: /(console|core)\.clikkle\.com/i, value: { id: "core", name: "Core", product: "Clikkle Core Cloud", type: "cloud-platform", preparingLabel: "Preparing Core…" } },
  { match: /(theo|ai)\.clikkle\.com/i, value: { id: "theo", name: "Theo", product: "Clikkle Theo AI", type: "ai-platform", preparingLabel: "Preparing Theo…" } },
  { match: /myaccount\.clikkle\.com/i, value: { id: "account", name: "My Account", product: "Clikkle Account", type: "account", preparingLabel: "Preparing your account…" } },
  { match: /(developer|developers)\.clikkle\.com/i, value: { id: "developer", name: "Developer", product: "Clikkle Developer Platform", type: "developer-platform", preparingLabel: "Preparing Developer…" } },
]);

function safeString(value) { return typeof value === "string" ? value.trim() : ""; }

export function resolveDestination({ redirectUrl, referralApp } = {}) {
  const haystack = `${safeString(redirectUrl)} ${safeString(referralApp)}`;
  const matched = DESTINATION_RULES.find(({ match }) => match.test(haystack));
  if (matched) return matched.value;
  const referral = safeString(referralApp);
  if (referral && !/^your clikkle (workspace|destination)$/i.test(referral)) {
    return { ...GENERIC_DESTINATION, id: "custom", name: referral, product: referral, preparingLabel: `Preparing ${referral}…` };
  }
  return GENERIC_DESTINATION;
}

export function getDestinationContext({ redirectUrl, referralApp } = {}) {
  const destination = resolveDestination({ redirectUrl, referralApp });
  return { ...destination, continuingLabel: destination.product, successLabel: destination.preparingLabel };
}

export { GENERIC_DESTINATION };
